const KEY = 'action_challenges'

// No 0/O/I/1 to avoid confusion when typing
const CODE_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

function safeGet() {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function safeSet(obj) {
  try {
    localStorage.setItem(KEY, JSON.stringify(obj))
  } catch {}
}

export function generateGameCode() {
  const all = safeGet()
  let code
  do {
    code = ''
    for (let i = 0; i < 6; i++) {
      code += CODE_CHARS[Math.floor(Math.random() * CODE_CHARS.length)]
    }
  } while (all[code])
  return code
}

export function getChallenge(gameId) {
  if (!gameId) return null
  return safeGet()[gameId.toUpperCase()] ?? null
}

export function saveChallenge(challenge) {
  const all = safeGet()
  all[challenge.gameId] = challenge
  safeSet(all)
  return challenge
}

export function updateChallenge(gameId, patch) {
  if (!gameId) return null
  const all = safeGet()
  const key = gameId.toUpperCase()
  if (!all[key]) return null
  all[key] = { ...all[key], ...patch }
  safeSet(all)
  return all[key]
}

export function getAllChallenges() {
  const all = safeGet()
  return Object.values(all).sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
  )
}

// Minimal actor snapshot for storage (strip anything not needed for rendering)
export function actorSnapshot(actor) {
  return {
    id: actor.id,
    name: actor.name,
    profile_path: actor.profile_path,
    gender: actor.gender,
    popularity: actor.popularity,
  }
}

// Determine winner: fewest moves, time as tiebreaker. Returns 1, 2, or 0 for tie.
export function getWinner(challenge) {
  const p1 = challenge.player1Result
  const p2 = challenge.player2Result
  if (!p1 || !p2) return null
  if (p1.moves < p2.moves) return 1
  if (p2.moves < p1.moves) return 2
  if ((p1.timeSeconds ?? 0) < (p2.timeSeconds ?? 0)) return 1
  if ((p2.timeSeconds ?? 0) < (p1.timeSeconds ?? 0)) return 2
  return 0
}
